import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MapPin, Calendar, Coins, Home as HomeIcon } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { API } from "@/lib/api";

export default function OfferCard({ offer }) {
  const { t } = useTranslation();

  return (
    <Link
      to={`/offers/${offer.id}`}
      className="block bg-white rounded-2xl border border-black/5 shadow-[0_4px_24px_rgba(0,0,0,0.03)] overflow-hidden hover:-translate-y-1 hover:border-black/10 transition-all duration-200"
      data-testid={`offer-card-${offer.id}`}
    >
      {offer.photos?.length > 0 && (
        <div className="h-36 w-full overflow-hidden">
          <img src={`${API}/profiles/files/${offer.photos[0]}`} alt="" className="h-full w-full object-cover" data-testid={`offer-card-cover-photo-${offer.id}`} />
        </div>
      )}
      <div className="p-6">
      <div className="flex items-start justify-between mb-3">
        <h3 className="font-heading font-bold text-lg">{t(`lookups.missionTypes.${offer.mission_type}`)}</h3>
        <div className="flex gap-2">
          {offer.is_boosted && (
            <Badge className="bg-[#dde165]/25 text-[#2B2B2B] border-0 rounded-full">{t("common.urgent")}</Badge>
          )}
        </div>
      </div>
      <div className="flex items-center gap-2 text-sm text-[#2B2B2B]/60 mb-4">
        <MapPin className="h-4 w-4 shrink-0" />
        {t(`lookups.regions.${offer.region}`)}, {t(`lookups.countries.${offer.country}`)}
      </div>
      <div className="space-y-2 text-sm">
        <div className="flex items-center gap-2 text-[#2B2B2B]/70">
          <Calendar className="h-4 w-4 shrink-0" />
          {offer.date_start} &rarr; {offer.date_end}
        </div>
        <div className="flex items-center gap-2 text-[#2B2B2B]/70">
          <Coins className="h-4 w-4 shrink-0" />
          {offer.salary_amount}&euro; / {t(`lookups.salaryPeriods.${offer.salary_period}`)}
        </div>
        <div className="flex items-center gap-2 text-[#2B2B2B]/70">
          <HomeIcon className="h-4 w-4 shrink-0" />
          {t(`lookups.housingOptions.${offer.housing}`)}
        </div>
      </div>
      {offer.producer?.company_name && (
        <p className="mt-4 pt-4 border-t border-black/5 text-sm font-semibold text-[#2B2B2B]/80">
          {offer.producer.company_name}
        </p>
      )}
      </div>
    </Link>
  );
}
